import React, { useEffect, useState } from "react";
import Header from "../../components/Header/Header";
import BottomNav from "../../components/BottomNav/BottomNav";
import "./ProfilePage.css";
import { useNavigate } from "react-router-dom";

const ProfilePage = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("profile");

  const [userData, setUserData] = useState({
    fullName: "John Doe",
    username: "@Retailer",
    phone: "9876543210",
  });

  // Load user data safely from localStorage
  useEffect(() => {
    try {
      const storedData = JSON.parse(localStorage.getItem("userData"));
      if (storedData) setUserData(storedData);
    } catch (err) {
      console.error("Failed to load userData:", err);
    }
  }, []);

  // Handle input changes
  const handleChange = (e) => {
    setUserData({ ...userData, [e.target.name]: e.target.value });
  };

  // Logout handler
  const handleLogout = () => {
    localStorage.removeItem("userData");
    navigate("/");
  };

  // Bottom nav tab change
  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    if (tabId === "dashboard") navigate("/dashboard");
    else if (tabId === "analytics") navigate("/analytics");
    else if (tabId === "profile") navigate("/profile");
  };

  return (
    <div className="phone-frame">
      <div className="profile-container">
        {/* Header */}
        <Header username={(userData.username || "@Retailer").replace("@", "")} />

        {/* Profile Content */}
        <div className="profile-content">
          <h2 className="profile-title">Profile</h2>

          <div className="profile-card">
            {/* Avatar */}
            <div className="avatar-placeholder">👤</div>

            {/* Input Fields */}
            <div className="input-group">
            <input
              type="text"
              name="fullName"
              value={userData.fullName}
              readOnly
              className="readonly-input"
            />
            <label>Full Name</label>
          </div>

          <div className="input-group">
            <input
              type="text"
              name="username"
              value={userData.username}
              readOnly
              className="readonly-input"
            />
            <label>User Name</label>
          </div>

          <div className="input-group">
            <input
              type="text"
              name="phone"
              value={userData.phone}
              readOnly
              className="readonly-input"
            />
            <label>Phone Number</label>
          </div>


            {/* Logout Button */}
            <button className="logout-btn" onClick={handleLogout}>
              Logout
            </button>
          </div>
        </div>

        {/* Bottom Navigation */}
        <BottomNav activeTab={activeTab} onTabChange={handleTabChange} />
      </div>
    </div>
  );
};

export default ProfilePage;
